import { ModalContent, Paragraph } from '@increasecard/typed-components';
import { useTranslation } from 'react-i18next';
import { Subscription } from '../../../types/Subscription';
import { MassiveActionResults } from './MassiveActionResults';
import { useApproveSubscriptions } from '../subscriptionQueries';
import { MassiveActionFooter } from './MassiveActionsFooter';

export interface ApproveModalProps {
  onClose: VoidFunction;
  onSuccess?: VoidFunction;
  subscription: Subscription[];
}

interface ApproveMessageProps {
  subscription: Subscription[];
}

function ApproveMessage({ subscription }: ApproveMessageProps) {
  const { t } = useTranslation();
  return (
    <Paragraph style={{ marginBottom: '1rem' }}>
      {t('screens.subscriptions.approve.subtitle', {
        count: subscription.length,
      })}
      {subscription.length === 1 ? (
        <Paragraph weight="bold">
          {t('screens.subscriptions.approve.subtitle2', {
            product: subscription[0].product.name,
            plan: subscription[0].plan.name,
          })}
        </Paragraph>
      ) : null}
    </Paragraph>
  );
}

export function ApproveModalContent({
  onClose,
  onSuccess,
  subscription,
}: ApproveModalProps): JSX.Element | null {
  const { t } = useTranslation();

  const { mutate, error, isError, isSuccess, isLoading } =
    useApproveSubscriptions();

  const handleApprove = () =>
    mutate(
      {
        subscriptions: subscription,
      },
      { onSuccess }
    );

  if (!subscription) return null;

  return (
    <>
      <ModalContent align="center">
        {!isError && !isSuccess && (
          <ApproveMessage subscription={subscription} />
        )}
        <MassiveActionResults
          subscriptions={subscription}
          error={error}
          isSuccess={isSuccess}
          actionType="approve"
        />
      </ModalContent>
      <MassiveActionFooter
        onClose={onClose}
        onConfirm={handleApprove}
        isLoading={isLoading}
        isError={isError}
        isSuccess={isSuccess}
        confirmLabel={t('screens.subscriptions.approve.confirm', {
          count: subscription.length,
        })}
      />
    </>
  );
}
